import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./moreResourcesSection.html";
import { MORE_RESOURCES_EVENT_CONTEXT } from '~/modules/analytics/analyticsHelper';
import { createUserActivity } from '~/modules/services/simplifiedTrialsService';
import { selectMoreResourcesSection, WireI18n } from '~/modules/stores/i18nStore';
class MoreResources extends LightningElement {
  constructor(...args) {
    super(...args);
    this.resourceSection = void 0;
    this.labels = void 0;
  }
  get sectionTitle() {
    // @ts-expect-error * Automated Type Error Fix
    return this.labels[this.resourceSection.type];
  }
  renderedCallback() {
    this.setBarColor();
  }
  setBarColor() {
    // @ts-expect-error * Automated Type Error Fix
    const bar = this.template.querySelector('.bar');
    bar.style.background = this.resourceSection.barColor;
  }
  handleAnalytics(event) {
    event.detail.customTitle = this.resourceSection.type;
    event.detail.context = MORE_RESOURCES_EVENT_CONTEXT;
    createUserActivity(this.resourceSection.type);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(MoreResources, {
  publicProps: {
    resourceSection: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectMoreResourcesSection
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(MoreResources, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;